import { useMutation } from '@tanstack/react-query';

import { config } from '~/config';
import { useRequest } from '~/lib/useRequest';
import { PutOfferResponse, PutOfferRequestBody } from '@ab/ams-school-api/types/private/v1';
import { hasKey } from '~/utils';

type UpsertOfferParams = Omit<PutOfferRequestBody['data']['attributes'], 'type'>;

export function useUpsertOffer(applicationId: string) {
  const request = useRequest();
  const { isLoading, mutateAsync } = useMutation(['offer', applicationId], async (payload: UpsertOfferParams) => {
    return await request<unknown>(`${config.apiHost}/private/v1/applications/${applicationId}/offer`, {
      method: 'PUT',
      body: {
        data: {
          id: applicationId,
          type: 'offer',
          attributes: payload,
        },
      } as unknown as object,
      isExpectedResponse,
    });
  });

  return {
    upsertOffer: mutateAsync,
    isLoadingUpsertOffer: isLoading,
  };
}

function isExpectedResponse(res: unknown): res is PutOfferResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
